import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import {
  BooleanInput,
  Edit,
  RadioButtonGroupInput,
  SelectInput,
  SimpleForm,
  TextInput,
  useRecordContext,
  useRefresh,
} from 'react-admin'
import { useFormContext } from 'react-hook-form'
import { CustomToolbar, formatPhone, validatePhone } from '../../../utils'
import { darkGrey } from '../../styles'
import config from '../../../config'

const ContactPrefParagraph = (props) => {
  return (
    <div>
      <Typography variant="subtitle1" style={{ color: darkGrey }}>
        Vous pouvez ici modifier vos préférences de contact. Elles seront prises
        en compte immédiatement.
      </Typography>
      <br />
    </div>
  )
}
export const PrefContact = (props) => {
  const { coproprietaire } = props
  const [enabledSave, setEnabledSave] = useState(false)
  const refresh = useRefresh()

  useEffect(() => {
    refresh()
  }, [coproprietaire])
  const onSuccess = () => {
    setEnabledSave(false)
  }
  return (
    <Box component={Paper} padding={'20px'}>
      <Edit
        resource="ext_contactpref"
        id={coproprietaire.id}
        title=""
        defaultValues={{ copro_id: coproprietaire.copro.id }}
        redirect={false}
        transform={(data) => {
          data.phone = formatPhone(data.phone)
          return data
        }}
        mutationOptions={{ onSuccess: onSuccess }}
        mutationMode={'optimistic'}
      >
        <SimpleForm
          toolbar={
            <CustomToolbar onClick={() => {}} alwaysEnable={enabledSave} />
          }
          variant="outlined"
        >
          <Grid container>
            <Grid item xs={12}>
              <ContactPrefParagraph />
            </Grid>
            <Grid item xs={6}>
              <SelectInput
                source="prefcontact"
                label="Préférence contact"
                choices={[
                  { id: 'all', name: 'Email et SMS' },
                  { id: 'email', name: 'Email' },
                  { id: 'sms', name: 'SMS' },
                ]}
              />
              <TextInput source="email" label="Email" />
              <TextInput
                source="phone"
                label="Mobile"
                validate={validatePhone}
              />
            </Grid>
            <Grid style={{ textAlign: 'center', margin: 'auto' }}>
              <img
                style={{
                  width: '215px',
                  margin: 'auto',
                }}
                src={`${config.PUBLIC_URL}/img/coowner_data_edit.svg`}
              />
            </Grid>
            <Grid item xs={12}>
              <RadioButtonGroupInput
                source="paper"
                choices={[
                  { id: 'true', name: 'Voie postale' },
                  { id: 'false', name: 'Voie digitale sécurisée' },
                ]}
              />
            </Grid>
          </Grid>
        </SimpleForm>
      </Edit>
    </Box>
  )
}

export default PrefContact
